/**
 * i18n-konfiguration. DA er default. EN routes med /en/ præfiks.
 */

export const locales = ["da", "en"] as const;
export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = "da";

export function isLocale(value: string): value is Locale {
  return (locales as readonly string[]).includes(value);
}

/**
 * Normaliserer pathname → returnerer { locale, pathnameWithoutLocale }
 * - "/en/priser" → { locale: 'en', path: '/priser' }
 * - "/priser"    → { locale: 'da', path: '/priser' }
 */
export function parsePathname(pathname: string): {
  locale: Locale;
  path: string;
} {
  const [, first, ...rest] = pathname.split("/");
  if (isLocale(first)) {
    return { locale: first, path: "/" + rest.join("/") };
  }
  return { locale: defaultLocale, path: pathname };
}

/**
 * Tager en sti og en target-locale → returnerer URL'en på det andet sprog.
 * - localizePath('/priser', 'en') → '/en/priser'
 * - localizePath('/en/priser', 'da') → '/priser'
 */
export function localizePath(path: string, target: Locale): string {
  const { path: cleanPath } = parsePathname(path);
  const normalized = cleanPath === "/" ? "" : cleanPath;
  if (target === defaultLocale) return normalized || "/";
  return `/${target}${normalized}`;
}
